<!-- <button mat-icon-button [matMenuTriggerFor]="menu"><mat-icon>more_vert</mat-icon></button> -->
<button mat-icon-button [matMenuTriggerFor]="menu" matToolTip = "more" class="icon-btn"><mat-icon class="icon-layout-mat-list">more_vert</mat-icon></button>
<mat-menu #menu="matMenu">
    <p class="vert-icon-p-tag">
        <button mat-menu-item (click) = "openNotesDialog()">
            <mat-icon>notes</mat-icon>
                <span>Notes</span>
        </button>
    </p>
                                <!-- No Need for the requirements -->

    <!-- <p class="vert-icon-p-tag">
        <button mat-menu-item (click) = "openPreDefinedDialog()">
            <mat-icon>speaker_notes</mat-icon>
                <span>Predefined notes</span>
        </button>
    </p> -->
    <p class="vert-icon-p-tag">
        <button mat-menu-item (click)="commonService.deleteAgenda(agList.agendaId)">
            <mat-icon>delete</mat-icon>
            <span>Delete</span>
        </button>
    </p>

</mat-menu>